import { useQuery } from "@tanstack/react-query";
import { fetchPerkUsersPeriods } from ".";

export const useListTotalRewardsPerkUsersPeriods = (
  companyId: string,
  asOptions?: boolean
) =>
  useQuery({
    queryKey: ["total-rewards-perk-users-periods", "list", { companyId }],
    queryFn: async ({ signal }) =>
      fetchPerkUsersPeriods(
        { tenant: companyId, "order[period]": "desc" },
        { signal }
      ),
    initialData: [],
    select(data) {
      return asOptions
        ? data.map((c: { period: string }) => ({
            value: c.period,
            label: c.period,
          }))
        : data;
    },
  });
